import TabPage from "./../../factories/tab-page";
import "./../../factories/tab-controller";
import "./../../bindings/bao-tabs";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import SubscriptionViewModel from "./../../factories/subscription-view-model";
import baoRouter from "./../../services/bao-router";
import BaoDialog from "./../../factories/bao-dialog";
import BaoMenu from "./../../services/bao-menu";
import finitoService from "./../../services/finito-service";
import TabController from "./../../factories/tab-controller";
class ShiftReportChecklist extends SubscriptionViewModel {
    Bao = Bao;
    TabPage: TabPage;
    PageSize = ko.observable(10);
    TotalRows = ko.observable(0);
    PageIndex = ko.observable(0);
    Sorting = ko.observableArray();
    Columns = ko.observableArray([]);
    Fields = ko.observableArray([]);
    EvaluationCollection = ko.observableArray([]);
    SelectedEvaluationRow = ko.observable();
    ToolbarButtons = ko.observableArray();
    OriginalTabTitle: string = "";
    CustomFilter = ko.observable({});
    ShiftReport: {
        ReportId: KnockoutObservable<string>;
        ShiftStartTime: KnockoutObservable<string>;
        ShiftEndTime: KnockoutObservable<string>;
    } = null;
    constructor(tabPage: TabPage, parent: any) {
        super(tabPage);
        this.TabPage = tabPage;
        this.ShiftReport = parent;
        this.SelectedEvaluationRow.subscribe(() => {
            this.ToggleToolbarButtons();
        });
        this.CustomFilter.subscribe(() => {
            this.LoadData();
        });
        Bao.bindEvent('checklist-evaluation:refresh', () => this.refresh());
    }
    init() {
        this.OriginalTabTitle = this.TabPage.Title();
        return this.LoadData();
    }
    loaded() {
        this.Sorting.subscribe(() => {
            this.LoadData();
        });
        this.PageIndex.subscribe(() => {
            this.LoadData();
        });
        this.PageSize.subscribe((newvalue) => {
            if (this.PageIndex() === 0) {
                this.LoadData();
            }
            else {
                this.PageIndex(0);
            }
        });
        this.TabPage.IsLoading(false);
    }
    ToolbarLoaded = () => {
        this.ToggleToolbarButtons();
    };
    ToggleToolbarButtons = () => {
        ko.utils.arrayForEach(this.ToolbarButtons(), (button: any) => {
            if (button.ActionKey() == "ShiftReportTabChecklistEdit") {
                button.Enabled(this.SelectedEvaluationRow() != null);
            }
            if (button.ActionKey() == "ShiftReportTabChecklistDelete") {
                button.Enabled(this.SelectedEvaluationRow() != null);
            }
        });
    };
    toolbarClick = (action) => {
        switch (action.ActionKey()) {
            case "ShiftReportTabChecklistNew":
                this.ShowCreateEvaluationDialog();
                break;
            case "ShiftReportTabChecklistEdit":
                if (this.SelectedEvaluationRow() != null) {
                    this.EditReportEvaluation(this.SelectedEvaluationRow());
                }
                break;
            case "ShiftReportTabChecklistDelete":
                if (this.SelectedEvaluationRow() != null) {
                    var yesnodialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDelete"), "yesno");
                    yesnodialog.DialogResult.subscribe((res) => {
                        if (res === true) {
                            this.TabPage.IsLoading(true);
                            this.DeleteReportEvaluation(this.ShiftReport.ReportId(), this.SelectedEvaluationRow())
                                .then(() => {
                                this.SelectedEvaluationRow(null);
                                this.LoadData();
                            })
                                .always(() => { this.TabPage.IsLoading(false); });
                        }
                    });
                }
                break;
            case "ShiftReportTabChecklistRefresh":
                this.refresh();
                break;
        }
        ;
    };
    SelectRow = (item) => {
        this.SelectedEvaluationRow(item.evaluation);
        return true;
    };
    LoadData() {
        this.TabPage.IsLoading(true);
        this.ToggleToolbarButtons();
        return this.getDataFromServer(this.ShiftReport.ReportId())
            .then(data => {
            this.EvaluationCollection(data.Evaluations);
            this.Columns(data.Columns);
            this.TotalRows(data.TotalRows);
            this.Fields(data.Fields);
            this.TabPage.IsLoading(false);
            this.TabPage.Title(this.OriginalTabTitle + " (" + data.TotalRows + ")");
        });
    }
    private getDataFromServer(reportid: string) {
        return Bao.post("ShiftReportTabChecklist/GetEvaluationCollection", JSON.stringify({
            reportId: reportid, pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting(),
            customFilter: this.ToHashObject(ko.unwrap(this.CustomFilter)),
            shiftStartTime: this.ShiftReport.ShiftStartTime(),
            shiftEndTime: this.ShiftReport.ShiftEndTime()
        }));
    }
    ToHashObject(customFilter) {
        var returnValue = [];
        for (var f in customFilter) {
            if (ko.unwrap(customFilter[f]).length > 0)
                returnValue.push({ Key: f, Value: ko.unwrap(customFilter[f]) });
        }
        return returnValue;
    }
    ;
    EditReportEvaluation = (item) => {
        baoRouter.setHash("checkware/evaluation/" + ko.unwrap(item.EvaluationId));
    };
    DeleteReportEvaluation = (reportId, evaluation) => {
        return Bao.post("ShiftReportTabChecklist/DeleteEvaluation", JSON.stringify({
            reportId: reportId, evaluationId: evaluation.EvaluationId
        }));
    };
    ShowCreateEvaluationDialog = () => {
        window.baorequire(['ViewModels/Dialogs/CreateEvaluationDialog'], (vm) => {
            var reportViewModel = { ReportViewModel: this.ShiftReport };
            var dialog = new vm(this.TabPage, reportViewModel);
            dialog.Show();
            dialog.DialogResult.subscribe(dialogResult => {
                if (dialogResult == true) {
                    this.CreateEvaluation(dialog.DialogViewModel.FolderStructureChecklistId(), this.ShiftReport.ReportId());
                }
            });
        });
    };
    refresh() {
        this.SelectedEvaluationRow(null);
        return this.LoadData();
    }
    ;
    CreateEvaluation(folderStructureChecklistId, reportId) {
        this.TabPage.IsLoading(true);
        return Bao.post("ShiftReportTabChecklist/CreateEvaluationByReport", JSON.stringify({
            folderStructureChecklistId: folderStructureChecklistId,
            reportId: reportId
        }), (result) => {
            if (result != false) {
                baoRouter.setHash("checkware/evaluation/" + result);
            }
            this.TabPage.IsLoading(false);
        }).then(_ => Bao.raiseEvent('checklist-evaluation:refresh', null));
    }
    ;
}
export default ShiftReportChecklist;